import React, { useState } from "react";
import { RiMenu3Line, RiCloseLine } from "react-icons/ri";
import { HashLink as Link } from "react-router-hash-link";
import "./navbar.css";

const logo = "/assets/img/logo.svg";

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <div className="scrobits__navbar">
      <div className="scrobits__navbar-links">
        <div className="scrobits__navbar-links_logo">
          <Link smooth to="/">
            {" "}
            <img src={logo} alt="logo of scrobits technologies" />
          </Link>
        </div>
        <div className="scrobits__navbar-links_container">
          <p>
            <Link smooth to="/#home">
              Home
            </Link>
          </p>
          <p>
            <Link smooth to="/#about-scrobits">
              About Us
            </Link>
          </p>
          <p>
            <Link smooth to="/#portfolio">
              Portfolio
            </Link>
          </p>
          <p>
            <Link smooth to="/#services">
              Services
            </Link>
          </p>
          <p>
            <Link smooth to="/#contact-us">
              Contact us
            </Link>
          </p>
          <p>
            <Link smooth to="/#career">
              career
            </Link>
          </p>
          <p>
            <Link smooth to="/get-started">
              Get Started
            </Link>
          </p>
        </div>
      </div>
      {/* <div className="scrobits__navbar-sign">
        <p>Sign in</p>
        <button type="button">Sign up</button>
      </div> */}
      <div className="scrobits__navbar-menu">
        {toggleMenu ? (
          <RiCloseLine
            color="#fff"
            size={27}
            onClick={() => setToggleMenu(false)}
          />
        ) : (
          <RiMenu3Line
            color="#fff"
            size={27}
            onClick={() => setToggleMenu(true)}
          />
        )}
        {toggleMenu && (
          <div className="scrobits__navbar-menu_container scale-up-center">
            <div className="scrobits__navbar-menu_container-links">
              <p>
                <Link smooth to="/#home">
                  Home
                </Link>
              </p>
              <p>
                <Link smooth to="/#about-scrobits">
                  About Us
                </Link>
              </p>
              <p>
                <Link smooth to="/#portfolio">
                  Portfolio
                </Link>
              </p>
              <p>
                <Link smooth to="/#services">
                  Services
                </Link>
              </p>
              <p>
                <Link smooth to="/#contact-us">
                  Contact us
                </Link>
              </p>
              <p>
                <Link smooth to="/#career">
                  career
                </Link>
              </p>
              <p>
                <Link smooth to="/get-quote">
                  Get Started
                </Link>
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
